import { getApi, postApi, putApi, deleteApi } from 'common/services/api';

class DocumentVerificationService {
    // List document verifications
    async listDocumentVerifications(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        return await getApi(`api/recruitment/document-verification${queryString ? `?${queryString}` : ''}`);
    }

    // Request documents - Send email to candidate
    async requestDocuments(data) {
        return await postApi('api/recruitment/document-verification/request', data);
    }

    // Get document verification by application ID
    async getDocumentVerification(applicationId) {
        return await getApi(`api/recruitment/document-verification/${applicationId}`);
    }

    // Get document verification by candidate ID (finds latest application)
    async getDocumentVerificationByCandidate(candidateId) {
        return await getApi(`api/recruitment/document-verification/candidate/${candidateId}`);
    }

    // Get presigned URL for document upload
    async getUploadPresignedUrl(data) {
        return await postApi('api/recruitment/document-verification/presigned-url', data);
    }

    // Save document metadata after S3 upload
    async saveDocumentMetadata(data) {
        return await postApi('api/recruitment/document-verification/save-metadata', data);
    }

    // Get presigned URL for viewing document
    async getDocumentViewUrl(verificationId, docId, category) {
        return await getApi(
            `api/recruitment/document-verification/${verificationId}/document/${docId}/view-url?category=${category}`
        );
    }

    // Update document status
    async updateDocumentStatus(verificationId, docId, data) {
        return await putApi(
            `api/recruitment/document-verification/${verificationId}/document/${docId}/status`,
            data
        );
    }

    // Submit for review
    async submitForReview(verificationId, data) {
        return await postApi(
            `api/recruitment/document-verification/${verificationId}/submit-for-review`,
            data
        );
    }

    // Review documents (Admin/Finance)
    async reviewDocuments(verificationId, data) {
        return await putApi(
            `api/recruitment/document-verification/${verificationId}/review`,
            data
        );
    }

    // Delete document
    async deleteDocument(verificationId, docId, category) {
        return await deleteApi(
            `api/recruitment/document-verification/${verificationId}/document/${docId}?category=${category}`,
            ''
        );
    }
}

export default new DocumentVerificationService();

